import React from "react";
import dayjs from "dayjs";
import {
  message,
  Empty,
  Table as AntdTable,
  DatePicker,
  Button as AntdButton,
  Select, Badge
} from "antd";
import axios from "axios";
import { Card, Row, Col } from "reactstrap";
import { CommentOutlined } from "@ant-design/icons";
import CommentsDrawer from "./CommentsDrawer.jsx";

class Refunds extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      refunds: [],
      selectedRefund: null,
      isCommentsDrawerOpen: false,
      customer: this.props.customer || null,
    };
    this.listRefunds = this.listRefunds.bind(this);
    this.formatDateISOAndTimestamp = this.formatDateISOAndTimestamp.bind(this);
    this.handleChangeClientStatus = this.handleChangeClientStatus.bind(this);
  }
  componentDidMount = () => {
    this.listRefunds();
  };
  listRefunds = async () => {
    try {
      const response = await axios.get(
        "https://backoffice.nadu.xyz/api/sepa-log",
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_BACKOFFICETOKEN}`,
          },
        }
      );
      if (response.data && response.data.ok) {
        this.setState({ refunds: response.data.message });
      }
    } catch (error) {
      console.error("Error fetching sepa info:", error);
      message.error("Error al obtener la información SEPA");
    }
  };
  handleChangeClientStatus = async (status, customer) => {
    try {
      const response = await axios.put(
        "https://backoffice.nadu.xyz/api/sepa-client/update-status",
        {
          client_id: customer,
          client_status: status,
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_BACKOFFICETOKEN}`,
          },
        }
      );
      if (response.data && response.data.ok) {
        message.success("Estado del cliente actualizado correctamente");
        this.listRefunds();
      }
    } catch (error) {
      console.error("Error fetching sepa info:", error);
      message.error("Error al obtener la información SEPA");
    }
  };
  formatDateISOAndTimestamp = (value) => {
    let date;

    if (typeof value === "number") {
      date = new Date(value);
    } else if (typeof value === "string") {
      if (/^\d+$/.test(value)) {
        date = new Date(parseInt(value, 10));
      } else {
        date = new Date(value);
      }
    } else {
      return "";
    }
    if (isNaN(date.getTime())) {
      return "";
    }
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };
  render() {
    const { refunds } = this.state;
    const reasonFilters = [...new Set(refunds.map((i) => i.reason))].map(
      (v) => ({ text: v, value: v })
    );

    const statusFilters = [...new Set(refunds.map((i) => i.client_status))].map(
      (v) => ({ text: v, value: v })
    );
    const dateFilterDropdown = (dataIndex) => ({
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <DatePicker
            onChange={(date) => {
              setSelectedKeys(date ? [date.format("DD/MM/YYYY")] : []);
              confirm();
            }}
            format="DD/MM/YYYY"
            placeholder="Selecciona la fecha"
            value={
              selectedKeys[0] ? dayjs(selectedKeys[0], "DD/MM/YYYY") : null
            }
            style={{ width: "100%" }}
          />
          <div style={{ display: "flex", marginTop: 8, gap: 10 }}>
            <AntdButton
              onClick={() => clearFilters()}
              size="small"
              style={{ flex: 1 }}
            >
              Limpiar
            </AntdButton>
            <AntdButton
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ flex: 1 }}
            >
              Vale
            </AntdButton>
          </div>
        </div>
      ),
      onFilter: (value, record) =>
        this.formatDateISOAndTimestamp(record[dataIndex]) === value,
    });

    return (
      <Row>
        <CommentsDrawer
          open={this.state.isCommentsDrawerOpen}
          onClose={() => this.setState({ isCommentsDrawerOpen: false })}
          selectedRefund={this.state.selectedRefund}
          refetch={this.listRefunds}
          customer={this.state.customer}
        />
        <Col xs={12}>
          <Card style={{ padding: 10 }}>
            <h5>Devoluciones</h5>
            <AntdTable
              dataSource={refunds}
              columns={[
                {
                  title: "Fecha de vencimiento",
                  dataIndex: "due_date",
                  key: "due_date",
                  align: "center",
                  ...dateFilterDropdown("due_date"),
                  render: (text) => this.formatDateISOAndTimestamp(text),
                  sorter: (a, b) => a.due_date - b.due_date,
                },
                {
                  title: "Importe",
                  dataIndex: "amount",
                  key: "amount",
                  align: "right",
                  sorter: (a, b) => a.amount_value - b.amount_value,
                },
                {
                  title: "Factura",
                  dataIndex: "bill",
                  key: "bill",
                  align: "center",
                },
                {
                  title: "Concepto",
                  dataIndex: "concept",
                  key: "concept",
                },
                {
                  title: "Creado",
                  dataIndex: "createdAt",
                  key: "createdAt",
                  align: "center",
                  ...dateFilterDropdown("createdAt"),
                  render: (text) => this.formatDateISOAndTimestamp(text),
                  sorter: (a, b) => a.createdAt - b.createdAt,
                },
                {
                  title: "Estado cliente",
                  dataIndex: "client_status",
                  key: "client_status",
                  align: "center",
                  filters: statusFilters,
                  onFilter: (val, rec) => rec.client_status === val,
                  render: (text, record) => {
                    return (
                      <div>
                        <Select
                          defaultValue={text}
                          style={{ width: 180 }}
                          onChange={(value) =>
                            this.handleChangeClientStatus(
                              value,
                              record.customer
                            )
                          }
                        >
                          <Select.Option
                            value="service_cut_off"
                            style={{
                              backgroundColor: "#FFF4E5", // naranja muy suave
                              color: "#FF7A00",
                            }}
                          >
                            Corte por impago
                          </Select.Option>
                          <Select.Option
                            value="return_notice"
                            style={{
                              backgroundColor: "#FFFAE6", // amarillo suave
                              color: "#C8A300",
                            }}
                          >
                            Avisado devolución
                          </Select.Option>
                          <Select.Option
                            value="cut_off_notice"
                            style={{
                              backgroundColor: "#FFF1F0", // rojo claro
                              color: "#FF4D4F",
                            }}
                          >
                            Avisado corte
                          </Select.Option>
                          <Select.Option
                            value="active"
                            style={{
                              backgroundColor: "#F6FFED", // verde clarito
                              color: "#52C41A",
                            }}
                          >
                            Activo
                          </Select.Option>
                          <Select.Option
                            value="inactive"
                            style={{
                              backgroundColor: "#F5F5F5", // gris suave
                              color: "#BFBFBF",
                            }}
                          >
                            Inactivo
                          </Select.Option>
                          <Select.Option
                            value="cancelled"
                            style={{
                              backgroundColor: "#FAFAFA", // gris aún más claro
                              color: "#BFBFBF",
                            }}
                          >
                            Cancelado
                          </Select.Option>
                        </Select>
                      </div>
                    );
                  },
                },
                {
                  title: "Deudor",
                  key: "debtor",
                  render: (record) => (
                    <a
                      target="_blank"
                      href={`https://oficina.nadunet.es/clientes/fichas/${record.customer}`}
                    >
                      {record.debtor}
                    </a>
                  ),
                },
                {
                  title: "Descripción",
                  dataIndex: "description",
                  key: "description",
                },
                {
                  title: "Detalle",
                  dataIndex: "detail",
                  key: "detail",
                },
                {
                  title: "IBAN",
                  dataIndex: "iban",
                  key: "iban",
                },
                {
                  title: "Motivo",
                  dataIndex: "reason",
                  key: "reason",
                  align: "center",
                  filters: reasonFilters,
                  onFilter: (val, rec) => rec.reason === val,
                },
                {
                  title: "Comentarios",
                  dataIndex: "sepa_comments",
                  key: "sepa_comments",
                  align: "center",
                  render: (text, record) => (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <AntdButton
                        style={{ display: "flex", alignItems: "center" }}
                        onClick={() => {
                          this.setState({
                            isCommentsDrawerOpen: true,
                            selectedRefund: record,
                          });
                        }}
                      >
                        {
                          record.sepa_comments && record.sepa_comments.length > 0
                            ? <Badge count={record.sepa_comments.length} />
                            : null
                        }
                        <CommentOutlined />
                      </AntdButton>
                    </div>
                  ),
                },
                {
                  title: "Devueltas",
                  dataIndex: "returned_bills_count",
                  key: "returned_bills_count",
                  align: "center",
                  sorter: (a, b) =>
                    a.returned_bills_count - b.returned_bills_count,
                },
                {
                  title: "Fecha de retorno",
                  dataIndex: "return_date",
                  key: "return_date",
                  align: "center",
                  ...dateFilterDropdown("return_date"),
                  render: (text) => this.formatDateISOAndTimestamp(text),
                },
                {
                  title: "Actualizado",
                  dataIndex: "updatedAt",
                  key: "updatedAt",
                  align: "center",
                  ...dateFilterDropdown("updatedAt"),
                  render: (text) => this.formatDateISOAndTimestamp(text),
                },
              ]}
              rowKey="id"
              scroll={{ x: "max-content" }}
              locale={{
                filterConfirm: "Vale",
                filterReset: "Restablecer",
                emptyText: (
                  <Empty
                    description={"No hay devoluciones"}
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                ),
              }}
            />
          </Card>
        </Col>
      </Row>
    );
  }
}

export default Refunds;



// WEBPACK FOOTER //
// ./src/views/Bills/components/Refunds.jsx